<script setup lang="ts">
import type { CheckboxEmits, CheckboxProps } from '/#/components/base/form/checkbox'
import type { WritableComputedRef } from 'vue'

import isArray from 'lodash-es/isArray'

const props = withDefaults(defineProps<CheckboxProps>(), {
  modelValue: false,
  indeterminate: false,
  disabled: false,
})

const emit = defineEmits<CheckboxEmits>()

const fieldContext = reactive(useFieldContext())

const model: WritableComputedRef<boolean> = computed({
  get() {
    return props.modelValue
  },
  set(value: any) {
    return emit('update:modelValue', value)
  },
})

// Check the modelValue's string situation, then return the boolean value
const situationOfModelValue: ComputedRef<boolean> = computed(() => {
  if (isArray(model.value)) return model.value.includes(props.value)
  return model.value
})

const appearance: ComputedRef<any> = computed(() => [
  { checked: situationOfModelValue.value },
  { disabled: props.disabled },
  { indeterminate: props.indeterminate },
])
</script>

<template>
  <div class="checkbox">
    <div class="checkbox-wrapper">
      <input
        :id="props.id || fieldContext.id"
        v-model="model"
       
        type="checkbox"
        :value="value"
        :disabled="disabled"
      />
      <label
        :for="props.id || fieldContext.id"
       
        :class="appearance"
      >
        <span class="checkmark" />
      </label>
    </div>
    <span class="text">
      <label :for="props.id || fieldContext.id">
        <slot v-bind="fieldContext">{{ label }}</slot>
      </label>
    </span>
  </div>
</template>
